import { useIsEditorApp } from "@core-ui/hooks/useIsEditorApp";
import type { ReactElement } from "react";
import { useAgentChatPanel } from "./hooks/useAgentChatPanel";

const AgentChatPanelController = (): null => {
	useAgentChatPanel();
	return null;
};

// The chat panel mounts only in the editors (CatalogFloatingPanels); elsewhere its sessions would be refused.
const AgentChatSessions = (): ReactElement => (useIsEditorApp() ? <AgentChatPanelController /> : null);

const AgentChatService = {
	Init: (): ReactElement => <AgentChatSessions />,
};

export default AgentChatService;
